module.exports = __webpack_public_path__ + "img/logo_pf.a452537e.png";